import { STOModel } from "src/models/base/sto-model";
import { IncomingMailDTO } from "src/models/incoming-mail";
import { BaseApiService } from "../base";

export class SendIncomingMailApiService extends BaseApiService<IncomingMailDTO, STOModel> {
  constructor() {
    super({
      servicePath: "/IncomingMail",
      loadItemsPath: "/SendIncomingMail",
    });
  }
}
